<template>
  <div class="trx-kartu-prakerja">
    <BlNavBarMv style="border-bottom: 1px solid #ebebeb" title="Detail voucher" has-back-button @handleBackButtonClick="onClickBack" />
    <div class="content">
      <VoucherCode v-if="transactionDetail" data-testid="voucher-code" class="m-16" :transaction-detail="transactionDetail" />
      <RedeemInstruction class="mt-32 m-16" />
      <div class="ph-16">
        <PrakerjaGamificationTransaction />
      </div>
      <DetailCourse v-if="transactionDetail" data-testid="voucher-detail" class="m-16" :transaction-detail="transactionDetail" />
      <div class="bg-ui-light p-4 border-t border-0 border-gray-5 border-solid" />
      <DetailInvoice v-if="transactionDetail" data-testid="detail-invoice" class="m-16" :transaction-detail="transactionDetail" />
      <div class="bg-ui-light p-4 border-t border-0 border-gray-5 border-solid" />
      <BantuanFooter :merchant-name="merchantName" :merchant-email="merchantEmail" :merchant-phone="merchantPhone" />
    </div>
  </div>
</template>

<script>
import {BlNavBarMv} from '@bukalapak/bazaar-mweb-latest';
import VoucherCode from 'shared/components/PrakerjaEdukarier/molecules/transaction/VoucherCode.vue';
import RedeemInstruction from '../components/PrakerjaTransactionDetailPage/RedeemInstruction.vue';
import DetailCourse from 'shared/components/PrakerjaEdukarier/molecules/transaction/DetailCourse.vue';
import DetailInvoice from 'shared/components/PrakerjaEdukarier/molecules/transaction/DetailInvoice.vue';
import BantuanFooter from '../components/PrakerjaTransactionDetailPage/BantuanFooter.vue';
import nativeHandler from 'src/shared/mixins/native-handler';
import PrakerjaGamificationTransaction from '../components/PrakerjaTransactionDetailPage/PrakerjaGamificationTransaction.vue';

export default {
  name: 'PrakerjaTransactionDetailPage',
  components: {
    BlNavBarMv,
    VoucherCode,
    RedeemInstruction,
    DetailCourse,
    DetailInvoice,
    BantuanFooter,
    PrakerjaGamificationTransaction,
  },
  mixins: [nativeHandler],
  data() {
    return {
      isLoading: false,
      transactionDetail: null,
    };
  },
  computed: {
    merchantName() {
      return this.transactionDetail?.merchant?.name || '';
    },
    merchantEmail() {
      return this.transactionDetail?.merchant?.email || '';
    },
    merchantPhone() {
      return this.transactionDetail?.merchant?.phone_number || '';
    },
    isLogin() {
      return window.USER.id !== '' && window.USER.id !== null;
    },
  },
  mounted() {
    if (!this.isLogin) {
      this.$router.replace({name: 'landing'});
    }
    this.init();
  },
  methods: {
    onClickBack() {
      this.backNative(() => {
        this.$router.go(-1);
      });
    },
    async init() {
      this.isLoading = true;
      this.$api
        .getPrakerjaTransactionDetail({
          id: this.$route.params.id,
        })
        .then(({data}) => {
          this.transactionDetail = data;
        })
        .catch(() => {
          this.transactionDetail = null;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  min-height: calc(100vh - 58px);
}
</style>
